import React from 'react'

import { YmAccountProps } from '../types/accountProps'
import { YandexMarketProductsTable, YandexMarketProductsTableProps } from './YandexMarketProductsTable'
import { createYmProductImportColumns } from '../types/yandexMarketColumns'
import { observer } from 'mobx-react-lite'

export type YandexMarketProductImportTableProps =
  Pick<YandexMarketProductsTableProps, 'products'>
  & YmAccountProps

export const YandexMarketProductImportTable =
  observer(
    ({account, products}: YandexMarketProductImportTableProps) =>
      <YandexMarketProductsTable products={products} columns={createYmProductImportColumns(account)}/>)